import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=0ad9e8b0"
import script from "./CustomSwitch.vue?vue&type=script&lang=ts"
export * from "./CustomSwitch.vue?vue&type=script&lang=ts"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=0ad9e8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports